import * as React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from "@material-ui/core/styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
            fontSize: 5
        },
    },
};

const useStyles = makeStyles({
    root: {
        background: '#EFEAE8',
        '&:focus': {
            background: '#EFEAE8',
          },
    },
  });

export default function SelectDefault(props) {
    const classes = useStyles()
    
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        props.setName(value);
    };

    return (
        <div>
            <FormControl style={{ width: '250px' }}>
                <Select
                    displayEmpty
                    value={props.name}
                    onChange={handleChange}
                    MenuProps={MenuProps}
                    inputProps={{ 
                        'arial-label': 'Without label',
                        style: {fontSize: 5},
                        classes: {
                            select: classes.root,
                        },
                    }}
                    disableUnderline
                >
                <MenuItem disabled value="">
                    <em>{props.placeholder}</em>
                </MenuItem>
                {props.names.map((item) => (
                    <MenuItem
                    key={item.value}
                    value={item.value}
                    >
                    {item.label}
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        </div>
    );
}
